import type { UpdateVMAgentPackageCompatibilityRequest } from '@/types';

const stableMinimumPattern = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/;
const rcMinimumPattern =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)-rc\.(0|[1-9]\d*)$/;

export interface VMAgentPackageCompatibilityForm {
  minimumStableClientVersion: string;
  minimumRCClientVersion: string;
  updateNote: string;
}

export function validateVMAgentPackageCompatibilityForm(
  form: VMAgentPackageCompatibilityForm,
): string | null {
  const stable = form.minimumStableClientVersion.trim();
  const rc = form.minimumRCClientVersion.trim();
  if (stable !== '' && !stableMinimumPattern.test(stable)) {
    return 'Stable 最低版本必须为 x.y.z，且数字不能有前导零';
  }
  if (rc !== '' && !rcMinimumPattern.test(rc)) {
    return 'RC 最低版本必须为 x.y.z-rc.n，且数字不能有前导零';
  }
  if (form.updateNote.trim() === '') {
    return '修改原因不能为空';
  }
  return null;
}

export function buildVMAgentPackageCompatibilityUpdateRequest(
  agentID: string,
  version: string,
  compatibilityRevision: number,
  form: VMAgentPackageCompatibilityForm,
): UpdateVMAgentPackageCompatibilityRequest {
  return {
    agent_id: agentID.trim(),
    version: version.trim(),
    minimum_stable_client_version: form.minimumStableClientVersion.trim(),
    minimum_rc_client_version: form.minimumRCClientVersion.trim(),
    expected_compatibility_revision: compatibilityRevision,
    update_note: form.updateNote.trim(),
  };
}

export function isCompatibilityRevisionConflict(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('response' in error)) {
    return false;
  }
  const response = error.response;
  return (
    typeof response === 'object' &&
    response !== null &&
    'status' in response &&
    response.status === 409
  );
}
